import PublicLayout from "@/components/PublicLayout";

export default function CookiePolicy() {
  return (
    <PublicLayout title="Cookie Policy" lastUpdated="Last Updated: June 2026"
      intro="This Cookie Policy explains how NextRota uses cookies and similar technologies when you visit our website or use our workforce scheduling and employee management platform. This Cookie Policy should be read together with our Privacy Policy. By continuing to use our website or services, you acknowledge the use of cookies as described in this policy, subject to any consent choices you make where required by law.">

      <h2>What Are Cookies?</h2>
      <p>Cookies are small text files stored on your computer, tablet, or mobile device when you visit a website. Cookies help websites recognise users, remember preferences, improve functionality, and provide security and analytics features. Cookies may be set by NextRota (“first-party cookies”) or by third-party service providers (“third-party cookies”).</p>

      <h2>Types of Cookies We Use</h2>

      <h3>Strictly Necessary Cookies</h3>
      <p>These cookies are essential for the operation of our website and services. Examples include:</p>
      <ul>
        <li>User authentication</li>
        <li>Session management</li>
        <li>Security controls</li>
        <li>Load balancing</li>
        <li>Fraud prevention</li>
        <li>Account login functionality</li>
      </ul>
      <p>Without these cookies, certain parts of the Services may not function correctly.</p>

      <h3>Functional Cookies</h3>
      <p>These cookies help us remember user preferences and settings, such as:</p>
      <ul>
        <li>Language preferences</li>
        <li>User interface preferences</li>
        <li>Login preferences</li>
        <li>Account settings</li>
      </ul>

      <h3>Analytics Cookies</h3>
      <p>We may use analytics technologies to understand how visitors use our website and services. Analytics information may include:</p>
      <ul>
        <li>Pages viewed</li>
        <li>Features used</li>
        <li>Session duration</li>
        <li>Browser information</li>
        <li>Device information</li>
        <li>Referral sources</li>
      </ul>
      <p>This information helps us improve our Services.</p>

      <h3>Performance Cookies</h3>
      <p>Performance cookies help us monitor website performance and identify technical issues. Examples include:</p>
      <ul>
        <li>Error monitoring</li>
        <li>Service diagnostics</li>
        <li>Platform performance measurement</li>
      </ul>

      <h3>Future Marketing Cookies</h3>
      <p>If NextRota introduces marketing, advertising, or remarketing activities in the future, additional cookies may be used to:</p>
      <ul>
        <li>Measure marketing effectiveness</li>
        <li>Understand campaign performance</li>
        <li>Improve advertising relevance</li>
      </ul>
      <p>Where required by law, consent will be obtained before such cookies are activated.</p>

      <h3>Third-Party Cookies</h3>
      <p>We may allow trusted third-party providers to place cookies or use similar technologies in connection with the Services. Examples may include:</p>
      <ul>
        <li>Payment processors</li>
        <li>Cloud service providers</li>
        <li>Authentication providers</li>
        <li>Analytics providers</li>
        <li>Customer support providers</li>
      </ul>
      <p>These third parties may collect information in accordance with their own privacy policies.</p>

      <h2>Information Collected Through Cookies</h2>
      <p>Cookies and similar technologies may collect:</p>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device type</li>
        <li>Operating system</li>
        <li>Session information</li>
        <li>Website usage information</li>
        <li>Referring website information</li>
        <li>Login activity</li>
      </ul>
      <p>This information may be used for security, functionality, analytics, and service improvement purposes.</p>

      <h2>Managing Cookies</h2>
      <p>Most web browsers allow users to:</p>
      <ul>
        <li>View stored cookies</li>
        <li>Delete cookies</li>
        <li>Block cookies</li>
        <li>Restrict cookie usage</li>
        <li>Configure cookie preferences</li>
      </ul>
      <p>Browser settings can typically be found within the browser’s privacy or security settings. Please note that disabling certain cookies may affect website functionality.</p>

      <h2>Global Privacy Control</h2>
      <p>Where required by applicable law, NextRota will honour legally recognised privacy preference signals and privacy rights requests.</p>

      <h2>International Transfers</h2>
      <p>Information collected through cookies may be processed in countries outside your country of residence. Where required, appropriate safeguards will be implemented to protect personal information transferred internationally.</p>

      <h2>Updates to This Cookie Policy</h2>
      <p>We may update this Cookie Policy from time to time. Changes will be posted on this page and become effective upon publication unless otherwise stated. Users are encouraged to review this Cookie Policy periodically.</p>

      <h2>Contact Us</h2>
      <p>If you have questions regarding this Cookie Policy, please contact:</p>
      <p>
        <strong>NextRota</strong><br/>
        Email: <a href="mailto:privacy@nextrota.com">privacy@nextrota.com</a><br/>
        Website: <a href="https://nextrota.com">https://nextrota.com</a>
      </p>
    </PublicLayout>
  );
}
